export const ROLES_AUTH0 = {
  user: 'Usuario',
  admin: 'Admin',
  master: 'Master',
}
